<template>
  <article id="PROFILE" class="container-fixed offset-bottom-4">
    <VSection label="common.profileTitle" mandatory>
      <VDescriptionList>
        <VEntry v-if="username && userProfile" name="common.profile" :value="userProfile" />
        <VEntry v-if="username && vpNo" name="common.vpNo" :value="vpNo" />
        <VEntry v-if="username && crm" name="common.crm" :value="$t('common.crm_' + crm)" />
        <template v-if="hasShowTechnicalInformation">
          <VEntry name="common.environment" :value="environment" />
          <VEntry name="common.version" :value="version" />
        </template>
      </VDescriptionList>
    </VSection>
  </article>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import VSection from '@/components/Section';
import VDescriptionList from '@/components/DescriptionList';
import VEntry from '@/components/DescriptionList/Entry';
import TitleMixin from '@/mixins/title';

export default {
  name: 'UserProfile',

  components: {
    VSection,
    VDescriptionList,
    VEntry,
  },

  mixins: [TitleMixin],

  data() {
    return {};
  },

  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },

    ...mapState('system', ['username', 'userProfile', 'vpNo', 'crm', 'natco', 'environment']),

    ...mapGetters('system', ['hasShowTechnicalInformation']),
  },
};
</script>
